import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api";
import { useAuth } from "../../app/useAuth";

import { loginAuth } from "../../app/auth";
import { useDispatch } from "react-redux";

export default function VerifySuccess() {
    const navigate = useNavigate();
    const auth = useAuth();
    const dispatch = useDispatch();

    useEffect(() => {
        api.get("/auth/myaccount")
            .then((response) => {
                const token = auth?.access_token;
                const data = response.data;

                const newAuthData = {
                    token: token,
                    auth_data: data,
                };
                if (token) {
                    dispatch(loginAuth(newAuthData));
                }
            })
            .catch((err) => console.log(err));
    }, []);

    return (
        <div
            className="d-flex mw-100 vh-100 align-items-center justify-content-center"
            style={{ position: "absolute", top: 0, left: 0, width: "100%" }}
        >
            <div className="p-5" style={{ width: 500, backgroundColor: "#d1e7dd", borderRadius: 15 }}>
                <div className="text-center">
                    <div className="h5 fw-bold">ยืนยันที่อยู่อีเมลเสร็จสิ้น</div>
                    <div className="mt-5 a-style" style={{ cursor: "pointer" }} onClick={() => navigate("/")}>
                        กลับหน้าแรก
                    </div>
                </div>
            </div>
        </div>
    );
}
